// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import SignedOutHeader, {
    SignedOutHeaderPresentationProps,
    SignedOutHeaderProps,
} from "@store/Library/Components/SignedOut/SignedOutHeader";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import { siteWidthStyles } from "@toolkit/Themes/common/mixins/common";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { FC, HTMLAttributes, PropsWithChildren } from "react";
import { css } from "styled-components";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";

export interface SignedOutFullLayoutPresentationProps extends ExpandStyles<SignedOutFullLayoutStyles> {}

export interface SignedOutFullLayoutProps extends SignedOutFullLayoutPresentationProps, HTMLAttributes<HTMLElement> {
    headerProps?: Omit<SignedOutHeaderProps, keyof SignedOutHeaderPresentationProps>;
}

export interface SignedOutFullLayoutStyles {
    wrapper?: InjectableCss;
    innerWrapper?: InjectableCss;
    signedOutHeader?: SignedOutHeaderPresentationProps;
    contentWrapper?: InjectableCss;
}

export const signedOutFullLayoutStyles: SignedOutFullLayoutStyles = {
    innerWrapper: {
        css: css`
            ${siteWidthStyles()}
            display: flex;
            flex-direction: column;
            gap: ${pxToRem(32)};
            width: 100%;
            padding-top: ${pxToRem(24)};
            padding-bottom: ${pxToRem(24)};

            ${breakpoint("md")} {
                gap: ${pxToRem(40)};
                padding-top: ${pxToRem(45)};
                padding-bottom: ${pxToRem(45)};
            }
        `,
    },
};

const SignedOutFullLayout: FC<PropsWithChildren<SignedOutFullLayoutProps>> = ({
    children,
    extendedStyles,
    overridedStyles,
    headerProps,
    ...htmlAttributes
}) => {
    const styles = useExpandProps(signedOutFullLayoutStyles, extendedStyles, overridedStyles);

    return (
        <StyledWrapper {...styles.wrapper} {...htmlAttributes}>
            <StyledWrapper {...styles.innerWrapper}>
                <SignedOutHeader {...styles.signedOutHeader} {...headerProps} />
                <StyledWrapper {...styles.contentWrapper}>{children}</StyledWrapper>
            </StyledWrapper>
        </StyledWrapper>
    );
};

export default SignedOutFullLayout;
